<template>
  <div v-if="visible" class="cookie-consent">
    <h3>We value your privacy</h3>
    <p style="text-align: justify;">
      We use cookies to enhance your browsing experience, serve personalized ads or content, and analyze our traffic.
      By clicking "Accept All", you consent to our use of cookies.
    </p>
    <div class="buttons">
      <button class="policy" @click="showPrivacyPolicy">Privacy Policy</button>
      <button class="reject" @click="declineCookies">Reject All</button>
      <button class="accept" @click="acceptCookies">Accept All</button>
    </div>
    <a-modal
      :visible="showPolicy"
      :closable="true"
      :maskClosable="true"
      :footer=null
      @cancel="closePrivacyPolicy"
      :width="900"
    >
    <div>
  <h2>Cookie Notice</h2>
  <p>
    At CAPmed-BC, we respect your privacy and are committed to being transparent about 
    how we use technology to improve your experience. Like many other digital platforms, 
    we use cookies to enhance your interaction with our website.
  </p>
  
  <p>
    As a bioinformatics data analysis website offering free without registration, 
    your privacy is our priority. Our use of cookies is strictly limited to preserving 
    user preferences and differentiating between users but does not include any personal 
    data collection.
  </p>
  
  <h3>What Are Cookies?</h3>
  <p>
    Cookies are small files that are downloaded to your computer or other internet-enabled 
    devices to enhance your web experience. They help us remember your settings and allow 
    you to navigate the site smoothly.
  </p>
  
  <h3>How We Use Cookies</h3>
  <p>
    Our cookies are used to make the CAPmed-BC website easy to use and tailor the 
    experience to your interests and needs. By using our site, you agree to our use of 
    cookies for this limited purpose. If you disagree, you can disable cookies through 
    your browser settings.
  </p>
  
  <h3>Cookie Management</h3>
  <p>
    You can manage your cookies through your browser settings, which can be configured to 
    alert you when a cookie is being recorded or to refuse certain cookies. Note that 
    refusing cookies may affect your website experience but will not eliminate your ability 
    to access essential functionalities.
  </p>
  
  <h3>Types of Cookies We Use</h3>
  <ul>
    <li><strong>Necessary Cookies:</strong> Essential for website functionality, allowing you to navigate the site 
    and use features. These cookies do not collect personal data.</li>
    <li><strong>Functionality Cookies:</strong> Remember choices you’ve made, like settings, to 
    enhance your experience. No personal data is stored with these cookies.</li>
  </ul>
  
  <p>
    By using CAPmed-BC, you consent to our use of cookies in accordance with this Cookie 
    Notice. For any inquiries, please contact us through our website's "About" form.
  </p>
  
  <p>
    For more information on managing cookies and their usage, please visit 
    <a href="https://www.allaboutcookies.org">allaboutcookies.org</a>.
  </p>
</div>

    </a-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: true,
      showPolicy: false,
    };
  },
  created() {
    this.checkCookie();
  },
  methods: {
    acceptCookies() {
      this.setCookie('cookiesAccepted', 'true', 365);
      this.visible = false;
    },
    declineCookies() {
      this.visible = false;
    },
    setCookie(name, value, days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      const expires = "; expires=" + date.toUTCString();
      document.cookie = name + "=" + value + expires + "; path=/";
    },
    getCookie(name) {
      const nameEQ = name + "=";
      const ca = document.cookie.split(';');
      for(let i=0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    },
    checkCookie() {
      const cookiesAccepted = this.getCookie('cookiesAccepted');
      if (cookiesAccepted) {
        this.visible = false;
      }
    },
    showPrivacyPolicy() {
      this.showPolicy = true;
    },
    closePrivacyPolicy() {
      this.showPolicy = false;
    }
  },
};
</script>

<style scoped>
.cookie-consent {
  position: fixed;
  bottom: 20px;
  left: 20px;
  max-width: 400px;
  background-color: #fff;
  border: 1px solid #ccc;
  padding: 20px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  font-family: Arial, sans-serif;
}

h3 {
  margin-top: 0;
  font-size: 18px;
  font-weight: bold;
}

p {
  font-size: 14px;
  line-height: 1.5;
  color: #555;
}

.buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
}

button {
  padding: 10px 15px;
  border: 1px solid transparent;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s, border-color 0.3s;
}

.reject {
  background-color: transparent;
  border-color: #dc3545;
  color: #dc3545;
}

.reject:hover {
  background-color: #fcebea;
}

.accept {
  background-color: #007bff;
  color: #fff;
  border-color: #007bff;
}

.accept:hover {
  background-color: #0056b3;
}

.policy {
  background-color: #28a745;
  color: #fff;
  border-color: #28a745;
}

.policy:hover {
  background-color: #218838;
}

.policy-content {
  margin-top: 20px;
  border-top: 1px solid #ddd;
  padding-top: 15px;
}
</style>
